/** Catalog / products / menu / tax feature reducers */
export async function loadCatalogReducers() {
  const [
    category,
    group,
    profiles,
    product,
    tax,
    ingredient,
    modifier,
    modGrp,
    allergens,
    typesAndAllergies,
    menu,
    productsAvailability,
    priceLevel,
  ] = await Promise.all([
    import('../reducers/CategoryReducer'),
    import('../reducers/GroupReducer'),
    import('../reducers/ProfileReducer'),
    import('../reducers/ProductsReducer'),
    import('../reducers/TaxReducer'),
    import('../reducers/IngredientReducer'),
    import('../reducers/ModifiersReducer'),
    import('../reducers/ModifiersGroupsReducer'),
    import('../reducers/AllergensReducer'),
    import('../reducers/TypesAndAllergiesReducer'),
    import('../reducers/MenuReducer'),
    import('../reducers/ProductsAvailabilityReducer'),
    import('../reducers/PriceLevelReducer'),
  ]);

  return {
    category: category.default,
    group: group.default,
    profiles: profiles.default,
    product: product.default,
    tax: tax.default,
    ingredient: ingredient.default,
    modifier: modifier.default,
    modGrp: modGrp.default,
    allergens: allergens.default,
    typesAndAllergies: typesAndAllergies.default,
    menu: menu.default,
    productsAvailability: productsAvailability.default,
    priceLevel: priceLevel.default,
  };
}
